import React, { useMemo } from 'react';
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Slider,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { DEFAULT_GEO_HEATMAP } from '../../utils/geoHeatmapConfig';

function SliderRow({ label, value, display, min, max, step, onChange }) {
  return (
    <Box sx={{ px: 0.25 }}>
      <Typography variant="caption" color="text.secondary" display="block">
        {label}: {display}
      </Typography>
      <Slider size="small" min={min} max={max} step={step} value={value} onChange={(_, v) => onChange(v)} />
    </Box>
  );
}

/** Opciones del heatmap geo en Chart Builder. */
export default function GeoHeatmapSettingsFields({
  config = {},
  onConfigChange,
  fieldOptions = [],
}) {
  const cfg = { ...DEFAULT_GEO_HEATMAP, ...config };

  const weightOptions = useMemo(
    () => [{ value: '', label: '(conteo de puntos)' }, ...fieldOptions],
    [fieldOptions]
  );

  const patch = (p) => onConfigChange?.({ ...cfg, ...p });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Typography variant="caption" color="text.secondary">
        Mapa OpenStreetMap · coordenadas WGS84 (lat/lng)
      </Typography>
      <FormControl size="small" fullWidth>
        <InputLabel>Peso / intensidad</InputLabel>
        <Select
          label="Peso / intensidad"
          value={cfg.weightColumn || ''}
          onChange={(e) =>
            patch({
              weightColumn: e.target.value,
              heatmapUseValue: Boolean(e.target.value),
            })
          }
        >
          {weightOptions.map((o) => (
            <MenuItem key={o.value || '__none'} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <SliderRow
        label="Radio del calor"
        value={cfg.heatmapRadius}
        display={cfg.heatmapRadius}
        min={5}
        max={60}
        step={1}
        onChange={(v) => patch({ heatmapRadius: v })}
      />
      <SliderRow
        label="Difuminado"
        value={cfg.heatmapBlur}
        display={cfg.heatmapBlur}
        min={1}
        max={40}
        step={1}
        onChange={(v) => patch({ heatmapBlur: v })}
      />
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={cfg.showLegend !== false}
            onChange={(e) => patch({ showLegend: e.target.checked })}
          />
        }
        label="Mostrar leyenda de intensidad"
      />
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={cfg.fitBoundsOnLoad !== false}
            onChange={(e) => patch({ fitBoundsOnLoad: e.target.checked })}
          />
        }
        label="Ajustar zoom a los datos"
      />
    </Box>
  );
}
